import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import moment from "moment";
import { Button, Modal } from "react-bootstrap-v5";
import JobService from "../../../Services/JobService";
import { toast } from "react-toastify";
import Loader from "../../../Components/Loader";
import ReactPaginate from "react-paginate";
import { revenuecostService } from "../../../Services/revenuecostService";
import { MdEdit, MdDelete, MdVisibility } from "react-icons/md";
import { Storage } from "../../../Storage/Storage";
import { useLocation } from "react-router-dom";
import CheckAccess from "../../../Function/CheckAccess";

let currentPage1 = 1;
export const JobList = () => {
  const history = useHistory();
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);
  const [jobItem, setJobItem] = useState([]);
  const [startDate, setStarDate] = useState();
  const [endDate, setEndData] = useState();
  const [searchField, setSearchField] = useState();
  const [loader, setLoader] = useState(true);
  const [archiveModal, setArchiveModal] = useState(false);
  const [jobId, setJobId] = useState("");

  const location = useLocation();
  let user_type = localStorage.getItem("user_type");

  const getStyle = {
    valueContainer: (provided) => ({
      ...provided,
      height: "calc(2.15rem + 2px)",
      overflowY: "visible",
    }),
    control: (provider) => ({
      ...provider,
      width: "200px",
      boxShadow: "0 0 0 0px #f46a6a",
    }),
    placeholder: (provider) => ({
      ...provider,
      color: "#a0b0ca",
    }),
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1;
    setCurrentPage(e.selected + 1);
    getJobList(e.selected + 1, searchField, startDate, endDate);
  };

  // useEffect(() => {
  //     getJobList(currentPage);
  // }, []);

  useEffect(() => {
    signInIntuit();
  }, []);

  const signInIntuit = () => {
    var win;
    var parameters = "location=1,width=800,height=650";
    parameters +=
      ",left=" +
      (window.innerWidth - 800) / 2 +
      ",top=" +
      (window.innerHeight - 650) / 2;
    setLoader(true);
    revenuecostService.qbookAuth().then((result) => {
      // setLoader(false)
      // Launch Popup
      // win = window.open(result, 'connectPopup', parameters);
      // this.props.history.push(result)

      if (!result.status) {
        localStorage.setItem("redirectUri", window.location.href);
        if (result?.uri) {
          window.location.href = result.uri;
        } else {
          Storage.remove("auth");
        }
      } else {
        getJobList(currentPage);
      }
    });
  };

  const getJobList = (curpage = 1,search,start_date,end_date) => {
    setSearchField(search)
    setStarDate(start_date)
    setEndData(end_date)
    setCurrentPage(curpage)
    let param = { page: curpage, limit:pagination.limit, is_deleted:false, is_job_open:"OPEN" };
    if (start_date && end_date) {
      param["start_date"] = getTimeStamp(start_date);
      param["end_date"] = getTimeStamp(end_date);
    }
    if (search) {
      param["search"] = search;
      // param.page = 1
    }
    setLoader(true);
    JobService.getJobapi(param).then((result) => {
      if (result.status === true) {
        let data = result.data.map((item, i) => {
          if (item?.invoice_status && item?.cost_status) {
            if (
              item.invoice_status.length === 0 &&
              item.cost_status.length === 0
            ) {
              item.invoice_cost_status = "white";
            } else {
              let invoice_pending =
                item.invoice_status.length > 0
                  ? item.invoice_status.map((itm) => itm.draft).includes(true)
                    ? true
                    : false
                  : true;
              let cost_pending =
                item.cost_status.length > 0
                  ? item.cost_status.map((itm) => itm.draft).includes(true)
                    ? true
                    : false
                  : true;
              if (invoice_pending || cost_pending) {
                item.invoice_cost_status = "#f3bb55";
              } else {
                item.invoice_cost_status = "#75f8c9";
              }
            }
          } else {
            item.invoice_cost_status = "white";
          }
          return item;
        });
        // console.log(data,'datadatadata')
        setJobItem(data);
        setPagination({ ...pagination, ...result.pagination });
        setLoader(false);
      } else {
        if(result!==false) setLoader(false);
      }
    });
  };

  const getTimeStamp = (date) => {
    let SingleTimestamp = new Date(date);
    return SingleTimestamp.getTime();
  };

  const getSumValue = (array) => {
    let plusVolume = array
      .map((item) => item.booking.total_volume_CBM)
      .reduce((prev, cur) => prev + cur, 0);

    let plusWeight = array
      .map((item) => item.booking.total_weight_KG)
      .reduce((prev, cur) => prev + cur, 0);

    let plusPackage = array
      .map((item) => item.booking.no_of_pkgs)
      .reduce((prev, cur) => prev + cur, 0);

    return {
      totalvolume: plusVolume.toFixed(2),
      totalweight: plusWeight,
      totalpkg: plusPackage,
    };
  };

  const handleArchiveSubmit = () => {
    let params = { job_token: jobId };
    JobService.deleteJob(params)
      .then((res) => {
        setArchiveModal(false);
        getJobList(currentPage);
        toast.success(res.data.message);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const getAddressString = (city, country) => {
    let str = city
    if(country){
      if(country==="United Arab Emirates"){
        str += (" ,UAE")
      }else{
        str += (" ,"+ country)
      }
    }
    return str
  }

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card" style={{ minHeight: "500px" }}>
          <div className="card-body">
            <div className="row align-items-end table_filter ">
              <div className="col-sm-3 mb-2">
                <label className="mb-0">Search</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search.."
                  onChange={(e) =>
                    getJobList(1, e.target.value, startDate, endDate)
                  }
                  value={searchField}
                />
              </div>
              <div className="col-sm-3 mb-2">
                <label className="mb-0">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) =>
                    getJobList(1, searchField, e.target.value, endDate)
                  }
                  value={startDate}
                />
              </div>
              <div className="col-sm-3 mb-2">
                <label className="mb-0">End Date</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) =>
                    getJobList(1, searchField, startDate, e.target.value)
                  }
                  value={endDate}
                />
              </div>

              <div className="col-sm-3 mb-2 d-flex justify-content-end gap-3">
                <button
                  className="btn btn-primary w-sm waves-effect waves-light"
                  onClick={() => getJobList(currentPage)}
                >
                  Reset
                </button>
              {
                CheckAccess(412,"add") && 
                <button
                  className="btn btn-primary w-sm waves-effect waves-light"
                  onClick={() => history.push("/add-job-card")}
                >
                  Add +
                </button>
              }
              </div>
              {/* <div className="col-2">
              </div> */}
            </div>

            <div className="table-responsive position-relative">
            {/* table-nowrap */}
              <table className="table table-nowrap mb-0 position-relative">
                <thead className="table-light py-5">
                  <tr>
                    <th className="pt-1 text-nowrap">S. <br /> No.</th>
                    <th className="pt-1 text-nowrap"> Job No.</th>
                    <th className="pt-1 text-nowrap"> Shipping Mode</th>
                    <th className="pt-1 text-nowrap" >Customer Name</th>
                    <th className="pt-1 text-nowrap">Job Date</th>
                    <th className="pt-1">Origin</th>
                    <th className="pt-1">Destination</th>
                    <th className="pt-1 text-center">Action</th>
                  </tr>

                  {/* <tr className="splittingCol">
                    <td>No. of Packages</td>
                    <td>
                      Total <br /> Volume
                    </td>
                    <td>Total Weight</td>
                  </tr> */}
                </thead>
                <tbody>
                  {jobItem &&
                    jobItem.length > 0 &&
                    jobItem.map((val, key) => {
                      if (Array.isArray(val.quote_request_items)) {
                        if (val.quote_request_items.booking) {
                          var calculateVal = getSumValue(
                            val.quote_request_items
                          );
                        }
                      }
                      return (
                        <tr key={key} style={{backgroundColor:`${val?.invoice_cost_status ? val.invoice_cost_status : 'white'}`}}>
                          <td scope="row" > {(pagination.page - 1) * pagination.limit + (key + 1)}</td>
                          <td className="text-nowrap">{val.job_token}</td>
                          {/* <td>{val.quote_token}</td> */}
                          <td>
                            <span className="badge rounded-pill font-size-12 pointer bg-success">
                              {(val && val.shipment_details.shipment_mode) ||
                                "UNPAID"}
                            </span>
                          </td>

                          <td className="str-hover-show" showfullonhover={val?.general_details?.retailer_name || val?.general_details?.sales_person?.retailer_name || val?.retailer_details?.[0]?.retailer_name || val?.retailer_details?.[0]?.contact_name || val?.general_details?.sales_person?.contact_name}>{(() => { const name = val?.general_details?.retailer_name || val?.general_details?.sales_person?.retailer_name || val?.retailer_details?.[0]?.retailer_name || val?.retailer_details?.[0]?.contact_name || val?.general_details?.sales_person?.contact_name || "NA"; return name.length > 20 ? `${name.slice(0, 20)}...` : name; })()}</td>
                          <td className="text-nowrap">{moment(val.created_at).format("DD-MM-YYYY")}</td>
                          {/* <td>
                            <div>{calculateVal.totalpkg}</div>
                          </td>
                          <td>
                            <div>{calculateVal.totalvolume || "NA"}</div>
                          </td>
                          <td>
                            <div>{calculateVal.totalweight}</div>
                          </td> */}

                          <td>{getAddressString(val.shipment_details.origin, val.shipment_details?.origin_country)}</td>
                          <td>{getAddressString(val.shipment_details.destination, val.shipment_details?.destination_country)}</td>
                          {/* <td>
                            <span className="badge rounded-pill font-size-12 pointer bg-success">
                              {(val.payment_information &&
                                val.payment_information.payment_status) ||
                                "UNPAID"}
                            </span>{" "}
                          </td> */}
                          <td className="d-flex justify-content-center">
                            {/* <MdVisibility
                              className="pointer"
                              onClick={() =>
                                // history.push("/job-details?id=" + val._id, val)
                                toast.info("Job detail under development")
                              }
                              color="#0323fe"
                              size="25px"
                            /> */}

                            <MdVisibility
                              className="pointer"
                              // onClick={() => }
                              // onClick={() => {
                              //   handleSubcategory(item?._id);
                              //   setSubCategoryModal(true);
                              // }}
                              onClick={
                                () =>
                                  history.push(
                                    "/view-job-cart?id=" + val._id,
                                    val
                                  )
                                // history.push(
                                //   "/edit-job-cart?id=" + val._id + "&isview=1",
                                //   val
                                // )
                              }
                              color="#0323fe"
                              size="25px"
                            />

                            {val?.is_deleted ? null : (
                              <>
                                {(CheckAccess(412, "edit") ||
                                  user_type === "SUPERADMIN") && (
                                  <MdEdit
                                    className="pointer ms-1"
                                    onClick={() =>
                                      history.push(
                                        "/edit-job-cart?id=" + val._id,
                                        val
                                      )
                                    }
                                    color="#0323fe"
                                    size="25px"
                                  />
                                )}
                                {(CheckAccess(412, "delete") ||
                                  user_type === "SUPERADMIN") && (
                                  <MdDelete
                                    className="pointer text-danger ms-1"
                                    onClick={() => {
                                      setArchiveModal(true);
                                      setJobId(val.job_token);
                                    }}
                                    size="25px"
                                  />
                                )}
                              </>
                            )}
                          </td>
                        </tr>
                      );
                    })}    
                </tbody>
              </table>
              <Loader isShow={loader} position={jobItem.length > 0 ? "absolute" : "relative"} />

              {jobItem &&
                jobItem.length > 0 &&
                pagination.totalRecord > pagination.limit && (
                  <ReactPaginate
                    previousLabel={
                      <img
                        src="assets/images/prev.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    forcePage={currentPage - 1}
                    nextLabel={
                      <img
                        src="assets/images/next.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={Math.ceil(
                      pagination.totalRecord / pagination.limit
                    )}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={(e) => onPageChangeEvent(e)}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                )}

              {jobItem && jobItem.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}

            </div>
            <Modal
              size="sm"
              show={archiveModal}
              onHide={() => setArchiveModal(false)}
              aria-labelledby="example-modal-sizes-title-lg"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  Delete Job
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>Are You Sure Want to Delete Job</Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setArchiveModal(false)}
                >
                  Close
                </Button>
                <Button variant="primary" onClick={handleArchiveSubmit}>
                  Confirm
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};
